import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { DownloadEnterprisePlanRequest, DownloadEnterprisePlanResponse } from '../interfaces/download-enterprisePlan.model';

@Injectable({
  providedIn: 'root',
})
export class DownloadEnterprisePlanService {
  http: HttpClient = inject(HttpClient);

  /**
   * 下載企業方案比較表 (CB-031)
   * @param request 
   */
  downloadEnterprisePlan(
    request: DownloadEnterprisePlanRequest
  ): Observable<HttpResponse<Blob>> {
    return this.http.post(
      API_ENDPOINTS.DOWNLOAD_ENTERPRISE_PLANS,
      request,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
}
